import { render } from "./TeachingPlanTemplateTab.vue?vue&type=template&id=90181b3e&scoped=true&ts=true"
import script from "./TeachingPlanTemplateTab.vue?vue&type=script&lang=ts"
export * from "./TeachingPlanTemplateTab.vue?vue&type=script&lang=ts"

import "./TeachingPlanTemplateTab.vue?vue&type=style&index=0&id=90181b3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90181b3e"]])

export default __exports__